export const getBSInfantFruitsAndVegsPackage = newProduct => {
  let newBSInfantFruitsAndVegsPackage = {
    UPC: newProduct.UPC,
    ProductType: newProduct.ProductType,
    PackageType: newProduct.PackageType,
    Size: newProduct.Size,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newBSInfantFruitsAndVegsPackage.MultiPackageCount =
      newProduct.MultiPackageCount
  }
  return newBSInfantFruitsAndVegsPackage
}

export const updateBSInfantFruitsAndVegsPackage = newProduct => {
  let newBSInfantFruitsAndVegsPackage = {
    UPC: newProduct.UPC,
    ProductType: newProduct.ProductType,
    PackageType: newProduct.PackageType,
    Size: newProduct.Size,
    NoAdditionalIngredients: newProduct.NoAdditionalIngredients,
    Organic: newProduct.Organic,
    MultiPackageType: newProduct.MultiPackageType,
  }
  if (newProduct.MultiPackageType === true) {
    newBSInfantFruitsAndVegsPackage.MultiPackageCount =
      newProduct.MultiPackageCount
  }
  return newBSInfantFruitsAndVegsPackage
}
